module.exports = "/images/vendor/desiigner-svg/svg/places/toys.svg?4f7c6c699e7320b593a9525540abcbaa";